import { motion } from 'framer-motion';

/**
 * Determines if the app is running in staging environment
 */
export function isStaging(): boolean {
  // Check if URL contains staging
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('staging') || hostname.includes('--staging-')) {
      return true;
    }
  }
  
  // Check environment variable if available
  const env = import.meta.env.MODE || import.meta.env.VITE_ENV;
  if (env === 'staging') {
    return true;
  }
  
  return false;
}

export function StagingBanner() {
  if (!isStaging()) {
    return null;
  }

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-orange-500 via-yellow-500 to-orange-500 text-white text-center py-2.5 px-4 shadow-lg"
        style={{
          background: 'linear-gradient(135deg, #F97316 0%, #FACC15 50%, #F97316 100%)',
          boxShadow: '0 4px 12px rgba(249, 115, 22, 0.4)',
        }}
      >
        <div className="flex items-center justify-center gap-2">
          <span className="text-sm font-bold uppercase tracking-wider">
            ⚠️ STAGING ENVIRONMENT
          </span>
          <span className="text-xs opacity-90 hidden sm:inline">
            This is a test environment - Data may be reset
          </span>
        </div>
      </motion.div>
      {/* Spacer to push content down */}
      <div style={{ height: '42px' }} />
    </>
  );
}
